import { RootState } from '../../../../../redux/root-reducer';
import { InvitationActions, INVITATION_ACTION_TYPE } from './invitation-type';
import { GetTncDetailHandlerResp } from './invitation-saga';
import { InvitationBanner } from '../types/banner';

export enum INVITATION_STATE_KEY {
  CONFIG = 'CONFIG',
  FORM = 'FORM',
  STEP = 'STEP',
  TNC_DETAIL = 'TNC_DETAIL',
}

export type InvitationConfig = {
  isTncAccepted: boolean,
  tncUrl: string,
  banner: string | null,
};

export type InvitationStep = 'form' | 'terms' | 'success';

export type InvitationFormData = {
  contactName: string,
  contactNumber: string,
  availableTime: string,
  token: string,
  campaignName: string,
  channel: string | null,
};

export type InvitationState = {
  [INVITATION_STATE_KEY.CONFIG]: InvitationConfig,
  [INVITATION_STATE_KEY.FORM]: InvitationFormData,
  [INVITATION_STATE_KEY.STEP]: InvitationStep,
  [INVITATION_STATE_KEY.TNC_DETAIL]: GetTncDetailHandlerResp | null,
};

const initialState: InvitationState = {
  [INVITATION_STATE_KEY.CONFIG]: {
    isTncAccepted: false,
    tncUrl: '',
    banner: InvitationBanner.SPECIAL_GP,
  },
  [INVITATION_STATE_KEY.FORM]: {
    contactName: '',
    contactNumber: '',
    availableTime: '09:00 - 12:00',
    token: '',
    campaignName: '',
    channel: null,
  },
  [INVITATION_STATE_KEY.STEP]: 'form',
  [INVITATION_STATE_KEY.TNC_DETAIL]: null,
};

export const invitationReducers = (state = initialState, action: InvitationActions) => {
  switch (action.type) {
    case INVITATION_ACTION_TYPE.SET_INVITATION_STATE:
      return {
        ...state,
        [action.payload.key]: action.payload.value
      };
    default:
      return state;
  }
};

export const invitationStateSelector = (key: INVITATION_STATE_KEY) => (state: RootState) => state.invitation[key];
